import React, { useEffect, useState, useCallback } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { ScanLine, Boxes, Trash2, FileQuestion, Bell } from "lucide-react";
import api from "../lib/api";

const items = [
  { to: "/scan", label: "Scan", icon: ScanLine, testid: "bottomnav-scan" },
  { to: "/inventory", label: "Stock", icon: Boxes, testid: "bottomnav-inventory" },
  { to: "/removals", label: "Removals", icon: Trash2, testid: "bottomnav-removals" },
  { to: "/requests", label: "Requests", icon: FileQuestion, testid: "bottomnav-requests" },
  { to: "/notifications", label: "Alerts", icon: Bell, testid: "bottomnav-notifications" },
];

export function BottomNav() {
  const [unread, setUnread] = useState(0);
  const location = useLocation();

  const loadUnread = useCallback(async () => {
    try {
      const { data } = await api.get("/notifications/unread-count");
      setUnread(data.count || 0);
    } catch {
      /* ignore */
    }
  }, []);

  useEffect(() => {
    loadUnread();
    const t = setInterval(loadUnread, 60000);
    return () => clearInterval(t);
  }, [loadUnread, location.pathname]);

  return (
    <nav className="fixed bottom-0 inset-x-0 bg-white border-t border-border z-30 shadow-[0_-2px_8px_rgba(0,0,0,0.04)]" data-testid="bottom-nav">
      <ul className="flex justify-around items-stretch h-[68px] pb-safe">
        {items.map(({ to, label, icon: Icon, testid }) => (
          <li key={to} className="flex-1">
            <NavLink
              to={to}
              data-testid={testid}
              className={({ isActive }) =>
                `h-full min-h-[56px] flex flex-col items-center justify-center gap-1 relative transition-colors ${
                  isActive
                    ? "text-brand font-display font-bold"
                    : "text-ink/60 hover:text-ink"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {isActive && (
                    <span
                      aria-hidden
                      className="absolute top-0 left-1/2 -translate-x-1/2 w-10 h-[3px] rounded-b-sm bg-brand"
                    />
                  )}
                  <div className="relative">
                    <Icon size={22} strokeWidth={2.25} />
                    {to === "/notifications" && unread > 0 && (
                      <span
                        data-testid="bottomnav-notifications-badge"
                        className="absolute -top-2 -right-3 min-w-[18px] h-[18px] px-1 rounded-full bg-brand text-white text-[10px] font-mono flex items-center justify-center"
                      >
                        {unread > 99 ? "99+" : unread}
                      </span>
                    )}
                  </div>
                  <span className="text-[10px] font-mono uppercase tracking-wider">{label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
